import { defineMessages } from "@/i18n";
import type { ShortcutId } from "@/lib/shortcut-registry";
import en from "./en";

export const settingsShortcutsMessages = defineMessages(
  "settings-shortcuts",
  en,
);

type Key = keyof typeof en;

/** How Settings names each shortcut. */
export const SHORTCUT_LABEL_KEY = {
  "shortcut.toggle_workspace": "labelToggleWorkspace",
  "shortcut.input.open": "labelInputOpen",
  "shortcut.voice.toggle": "labelVoiceToggle",
  "shortcut.dictation.anywhere": "labelDictationAnywhere",
  "shortcut.draw": "labelDraw",
  "shortcut.voice.continuous": "labelVoiceContinuous",
  "shortcut.voice.new": "labelVoiceNew",
  "shortcut.voice.cancel": "labelVoiceCancel",
  "shortcut.speech.stop": "labelSpeechStop",
  "shortcut.workspace.peek": "labelWorkspacePeek",
  "shortcut.frame.multiselect": "labelFrameMultiselect",
} as const satisfies Record<ShortcutId, Key>;

/** When a shortcut works, for the shortcuts that say so. */
export const SHORTCUT_CONTEXT_KEY: Partial<
  Record<ShortcutId, Extract<Key, `context${string}`>>
> = {
  "shortcut.dictation.anywhere": "contextDictationAnywhere",
  "shortcut.draw": "contextDraw",
  "shortcut.voice.cancel": "contextVoiceCancel",
  "shortcut.speech.stop": "contextSpeechStop",
  "shortcut.workspace.peek": "contextWorkspacePeek",
  "shortcut.frame.multiselect": "contextFrameMultiselect",
};
